var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfo({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 13,
    viewBox: "0 0 12 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.05398 11.6739C9.0325 11.6739 11.4471 9.2593 11.4471 6.28078C11.4471 3.30226 9.0325 0.887695 6.05398 0.887695C3.07546 0.887695 0.660889 3.30226 0.660889 6.28078C0.660889 9.2593 3.07546 11.6739 6.05398 11.6739Z",
    stroke: "black",
    strokeWidth: 0.980562,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.05371 8.438V6.28076",
    stroke: "black",
    strokeWidth: 0.980562,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.05371 4.1236H6.05932",
    stroke: "black",
    strokeWidth: 0.980562,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/Info.ec2cc7b56aebf857d4696d091e68d90f.svg";
export { ForwardRef as ReactComponent };